import styled from 'styled-components';

import { cssBreakpoints } from 'theme/theme';

export const PageHeaderForOrganizationsContainer = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: ${cssBreakpoints.lgDown}) {
    display: none;
  }
`;
